import React, { Component } from 'react';

import { Popover } from 'frontend-component-library';

import RecommendationProgramInfo from 'Components/Pages/Results/Recommendations/RecommendationProgramInfo';
import RecommendationMatch from 'Components/Pages/Results/Recommendations/RecommendationMatch';
import RecommendationActions from 'Components/Pages/Results/Recommendations/RecommendationActions';
import RecommendationLocation from 'Components/Pages/Results/Recommendations/RecommendationLocation';
import RecommendationHideMenu from 'Components/Pages/Results/Recommendations/RecommendationHideMenu';

class DNADatumPopover extends Component {
  render() {
    const {
      isOpen,
      recommendation,
      parentNode,
      areResultsOwnedByUser,
      closePopover,
    } = this.props;

    return (
      <Popover
        closePopover={closePopover}
        ref={node => (this.node = node)}
        parentNode={parentNode}
        isOpen={isOpen}
        className="DNADatumPopover"
      >
        {recommendation.is_hidden ? (
          <RecommendationHideMenu
            key={recommendation.uuid}
            recommendation={recommendation}
          />
        ) : (
          <React.Fragment>
            <Popover.Title closePopover={closePopover}>
              <RecommendationProgramInfo recommendation={recommendation} />
            </Popover.Title>
            <RecommendationMatch match={recommendation.matchPercentage}>
              <RecommendationActions
                showFavoriteButton={areResultsOwnedByUser}
                showHideButton={areResultsOwnedByUser}
                recommendation={recommendation}
              />
            </RecommendationMatch>
            <RecommendationLocation recommendation={recommendation} />
          </React.Fragment>
        )}
      </Popover>
    );
  }
}

export default DNADatumPopover;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/DNAGraph/DNADatumPopover.js